import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  autoSplitDefaultOption: {
    description: 'Label for the Default radio button option that will NOT auto split the product',
    defaultMessage: 'Do not auto-split this product',
    id: 'KLxr+r',
  },
  autoSplitShipProductSeparatelyOption: {
    description: 'Label that ensures this product has 1 shipment for each line item in the order, regardless of qty of line item',
    defaultMessage: 'Exclusive Bulk Shipping',
    id: 'Cr7pYN',
  },
  autoSplitShipProductSeparatelyOptionSubText: {
    description: 'sub text displayed under the "Can\t Ship with Others" radio button that describes what this option means',
    defaultMessage: 'Creates a new shipment for the entire quantity of this product',
    id: 'Dc33dl',
  },
  autoSplitShipProductIndividuallyOption: {
    description: 'Label that ensures this product has 1 shipment for each item in the order',
    defaultMessage: 'Ships Individually',
    id: 'LvSkSz',
  },
  autoSplitShipProductIndividuallyOptionSubText: {
    description: 'sub text displayed under the "Ship Alone" radio button that describes what this option means',
    defaultMessage: 'Creates a new shipment for each unit ordered of this product',
    id: 'HrkSdF',
  },
  autoSplitShipProductByCustomQtyOption: {
    description: 'Label that ensures this product has 1 shipment per custom qty entered by the seller',
    defaultMessage: 'Ship on Custom Quantity',
    id: 'FHWelY',
  },
  autoSplitShipProductByCustomQtyOptionSubText: {
    description: 'sub text displayed under the "Ship in Custom Quantity" radio button that describes what this option means',
    defaultMessage: 'Creates separate shipments for each specified quantity of this product',
    id: 'Udzn1B',
  },
  autoSplitShipProductByCustomQtyMustBeGreaterThanZero: {
    description: 'text to display if the user enters a value <=0 or leaves the input field blank',
    defaultMessage: 'The custom quantity must be greater than zero',
    id: 'heo1iO',
  },
});
